<template>
    <div class="dropdown filter_item" v-if="(location != '' && location != null)">
        <button class="btn m-r-5 waves-effect waves-light btn-default dropdown-toggle" type="button" data-toggle="dropdown" :class="{'btn-success': district_touched}">
            Bairro / Região
        </button>
        <div class="dropdown-menu dropdown-menu-left arrow-dropdown-menu arrow-menu-left dropdown-lg">
            <p class="h5 m-b-15">Bairro / Região</p>
            <input type="text" v-model="district_txt" name="district_txt" class='form-control' placeholder="Digite o nome do bairro"/>
            <div class="slimscroll m-t-10 dropdown-districts">
                <div v-for="dist in filtered_districts" v-bind:key="dist.district" class="checkbox checkbox-success">
                    <input type="checkbox"
                        :name="'district_' + dist.district"
                        :id="'district_' + dist.district"
                        :value="dist.district"
                        v-model="model">
                    <label :for="'district_' + dist.district">{{ dist.district }}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <button @click="filter()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            district_txt: '',
            model: this.$store.getters.getSelectedDistricts || []
        }
    },
    watch: {
        selected_districts: {
            handler(newVal) {
                this.model = newVal;
            },
        }
    },
    computed: {
        selected_districts() {
            return this.$store.getters.getSelectedDistricts || [];
        },
        filtered_districts() {
            return this.$store.getters.getDistricts.filter((item) => {
                return item.district.toLowerCase().indexOf(this.district_txt.toLowerCase()) > -1;
            });
        },
        location: function () {
            return this.$store.getters.getCitySlug;
        },
        district_touched() {
            return this.selected_districts.length > 0;
        },
    },
    methods: {
        filter() {
            this.$store.commit('setSelectedDistricts', this.model);
            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        }
    }
}
</script>

